<section>
  <span class="body1">{{ title() }}</span>
  @if (dataReading()) {
    <span class="subtitle2">{{ dataReading() | formatCamelCaseAlt }}</span>
  }
  @if (status()) {
    <app-status-indicator [status]="status()"></app-status-indicator>
  }
</section>
